export default {
  'zh-CN': {
    pleaseSelectDistrict: '请选择地区',
    theNational: '全国',
    selectAll: '全选'
  },
  'en': {
    pleaseSelectDistrict: 'Please select the region',
    theNational: 'Nationwide',
    selectAll: '全选'
  },
  'jp': {
  }
}
